// Duty breaks (unPaidBreakDuration / unBillBreakDuration) are stored as "H:MM" strings -
// Add Duty / Add Rota build them from the HH + MM inputs. Older records saved from the
// Breaks tab are plain minutes ("30"). Mirrors wfc-server's parseBreakDuration so the UI
// shows exactly what pay & bill was calculated with. Returns total minutes, 0 if invalid.
export const parseBreakDuration = (value) => {
    const input = String(value ?? "").trim();

    if (!input) return 0;

    // Digits only: interpret as total minutes.
    if (/^\d+$/.test(input)) {
        const minutes = Number(input);
        return Number.isSafeInteger(minutes) ? minutes : 0;
    }

    // Hours:minutes. Add Duty saves the HH + MM inputs as-is, so an empty side comes through
    // as "", "undefined" or "null" ("1:", ":30", "1:null") - treat that side as 0.
    const match = /^(\d*|undefined|null):(\d{0,2}|undefined|null)$/.exec(input);

    if (!match) return 0;

    const hours = /^\d+$/.test(match[1]) ? Number(match[1]) : 0;
    const minutes = /^\d+$/.test(match[2]) ? Number(match[2]) : 0;

    if (minutes > 59) return 0;

    const total = hours * 60 + minutes;

    return Number.isSafeInteger(hours) && Number.isSafeInteger(total) ? total : 0;
};

// Stored break -> HH / MM input values ("" leaves the input showing its placeholder).
export const splitBreakDuration = (value) => {
    const minutes = parseBreakDuration(value);
    if (!minutes) return { hour: "", minute: "" };
    return { hour: Math.floor(minutes / 60), minute: minutes % 60 };
};

// HH / MM input values -> stored "H:MM", whole numbers only.
export const formatBreakDuration = (hour, minute) => {
    const whole = (v) => Math.max(0, Math.trunc(Number(v) || 0));
    return `${whole(hour)}:${whole(minute)}`;
};

// InputNumber still accepts ".", "e" and "-" as you type - breaks are whole hours and
// minutes only. Pair with precision={0} so a pasted decimal is rounded on blur.
export const blockNonIntegerKeys = (e) => {
    if ([".", ",", "e", "E", "+", "-"].includes(e.key)) e.preventDefault();
};
